import React from 'react';
import SpeakingMap from '../components/SpeakingMap/SpeakingMap';

const Conferences: React.FC = () => {
  const conferenceStats = [
    { year: 2026, conferences: 10, talks: 11 },
    { year: 2025, conferences: 7, talks: 9 },
    { year: 2024, conferences: 19, talks: 24 },
    { year: 2023, conferences: 8, talks: 11 },
    { year: 2022, conferences: 32, talks: 33 },
    { year: 2021, conferences: 27, talks: 27 },
    { year: 2020, conferences: 15, talks: 15 },
    { year: 2019, conferences: 5, talks: 8 }
  ];

  return (
    <div className="page conferences">
      <div className="container">
        <section className="hero-section">
          <img 
            src="/images/54123118498_432756f02f_o.jpg" 
            alt="Pawel Piwosz Speaking" 
            className="conference-hero-image" 
          />
          <h1>Conference Speaking</h1>
        </section>
        
        <div className="intro-text">
          <p>Seasoned public speaker with expertise in DevOps, Cloud Architecture, and Infrastructure as Code.</p>
          <p>Keynote speaker at tech conferences across the World.</p>
        </div>

        <div className="conference-grid">
          {conferenceStats.map((stat) => (
            <div key={stat.year} className="conference-card">
              <h2>{stat.year}</h2>
              <div className="stats">
                <div className="stat-item">
                  <span className="stat-number">{stat.conferences}</span>
                  <span className="stat-label">Conferences</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">{stat.talks}</span>
                  <span className="stat-label">Talks</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <SpeakingMap />
      </div>
    </div>
  );
};

export default Conferences;